import maintainCustomer from './maintainCustomer'
export default maintainCustomer
